var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect-component',_vm._g(_vm._b({class:{ 'invalid': !_vm.isValid }},'treeselect-component',Object.assign({}, _vm.$attrs, _vm.additionalProps),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }